// extracted by mini-css-extract-plugin
module.exports = {"alert":"styles_alert__VzQUA","mainTitle":"styles_mainTitle__8xtve"};